export const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
